import { uniqBy } from 'lodash'

export const normalizeEvents = (p) => {
  const posts = p.edges ? p.edges : p.nodes ? p.nodes : p;
  return posts.map(node => {
    const { eventACF, tags, categories } = node;
    const type = eventACF
      ? (eventACF.kpopeventFlag ? 'kpop' : eventACF.showTvTop ? 'tv' : '')
      : '';
    const eventFloor = categories?.nodes?.[0]?.name ?? null;
    const artists = tags?.nodes ?? null;
    const title =
      artists?.length > 0
        ? artists.map(art => art.name).join(' / ')
        : node.title;
    let thumb = node.featuredImage?.node?.m ?? null;
    if (thumb) thumb = thumb.replace('http:', 'https:');

    return {
      title,
      header: node.title,
      type,
      eventFloor,
      thumb,
      databaseId: node.databaseId,
      date: eventACF.eventDate,
      ...eventACF,
      artists,
    };
  });
};

const initialState = {
  dbCalling: false,
  events: {},
  postById: {},
  tags: {},
  called: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ASN_FAILED': {
      const { mode, msg, stop } = action.payload || {};
      if (mode === 'safe_mode') return { ...state, safeMode: true };
      if (stop && window.confirm(msg)) window.location.href = '/';
      return state;
    }

    case 'SET_OBJ':
      return action.payload ? { ...state, ...action.payload } : state;

    case 'SET_PARAM': {
      const { key, val } = action.payload;
      return { ...state, [key]: val };
    }

    case 'SET_CAL_EVENTS': {
      const { eventDate, items } = action.payload || {};
      if (!items?.nodes) return state;
      const normalized = normalizeEvents(items);
      const yearMon = eventDate.slice(0, -1);
      const existing = state.events[yearMon];
      return {
        ...state,
        events: {
          ...state.events,
          [yearMon]: existing
            ? uniqBy([...existing, ...normalized], 'databaseId')
            : normalized,
        },
      };
    }

    case 'SET_CAL_NULL_EVENTS': {
      const { eventDate } = action.payload || {};
      const yearMon = eventDate.slice(0, -1);
      return {
        ...state,
        events: {
          ...state.events,
          [yearMon]: [],
        },
      };
    }

    default:
      return state;
  }
};

export default reducer;
